import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-drag",
  "use": "icon-drag-usage",
  "viewBox": "0 0 5.17 12.783",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 5.17 12.783\" id=\"icon-drag\">\r\n  <path id=\"icon-drag_拖动\" class=\"cls-1\" d=\"M341.333,85.333h1.58v1.58h-1.58Zm3.591,0h1.58v1.58h-1.58Zm-3.591,3.735h1.58v1.58h-1.58Zm3.591,0h1.58v1.58h-1.58ZM341.333,92.8h1.58v1.58h-1.58Zm3.591,0h1.58v1.58h-1.58Zm-3.591,3.735h1.58v1.58h-1.58Zm3.591,0h1.58v1.58h-1.58Z\" transform=\"translate(-341.333 -85.333)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol